import React from "react";
import { TextField, InputAdornment, Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Search as SearchIcon } from "tabler-icons-react";

function ReportsSearch({ value, onChange }) {
  const { t } = useTranslation();

  return (
    <Box sx={{ padding: "15px 0px 15px 0px" }}>
      <TextField
        fullWidth
        id="reports-search"
        placeholder={t("search")}
        value={value}
        onChange={onChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon size={22} strokeWidth={2} color="#8F9BB2" />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}

export default ReportsSearch;
